import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import { Icon } from '../components/ui';

const LINKS = [
  { to: '/book', label: 'Book a car wash' },
  { to: '/pricing', label: 'Prices and packages' },
  { to: '/mobile-car-wash-abu-dhabi', label: 'Mobile car wash Abu Dhabi' },
  { to: '/mobile-car-wash-dubai', label: 'Mobile car wash Dubai' },
  { to: '/contact', label: 'Contact us' }
];

const NotFound = () => (
  <>
    <Seo title="Page Not Found | Quick Way" description="The page you are looking for could not be found." path="/404" noindex />
    <section className="section not-found">
      <div className="container container--narrow center">
        <p className="eyebrow">Error 404</p>
        <h1>We could not find that page</h1>
        <p>The link may be out of date or the page may have moved. Try one of these instead:</p>
        <ul className="related related--center">
          {LINKS.map((l) => (
            <li key={l.to}><Link to={l.to} className="related__item"><span>{l.label}</span><Icon name="arrow" size={16} /></Link></li>
          ))}
        </ul>
        <Link to="/" className="btn btn-primary">Go to the homepage</Link>
      </div>
    </section>
  </>
);

export default NotFound;
